import { render, staticRenderFns } from "./WebAgency.vue?vue&type=template&id=15cdeb70&"
import script from "./WebAgency.vue?vue&type=script&lang=js&"
export * from "./WebAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports